const FILESPACE_SETTINGS_KEY_BASE = 'filespace_settings';
const FILESPACE_SETTINGS_GLOBAL_KEY_BASE = 'global';
const FILESPACE_SETTINGS_SET_KEY_BASE = 'set';
const FILESPACE_SETTINGS_UNSET_KEY_BASE = 'unset';
export const FilespaceSettingsKeyFactory = {
    all: () => [FILESPACE_SETTINGS_KEY_BASE],
    global: (filespaceId) => [
        ...FilespaceSettingsKeyFactory.all(),
        FILESPACE_SETTINGS_GLOBAL_KEY_BASE,
        filespaceId,
    ],
    setGlobal: (filespaceId, setting) => [
        ...FilespaceSettingsKeyFactory.all(),
        FILESPACE_SETTINGS_GLOBAL_KEY_BASE,
        FILESPACE_SETTINGS_SET_KEY_BASE,
        filespaceId,
        setting,
    ],
    unsetGlobal: (filespaceId, setting) => [
        ...FilespaceSettingsKeyFactory.all(),
        FILESPACE_SETTINGS_UNSET_KEY_BASE,
        filespaceId,
        setting,
    ],
};
